<template>
  <el-dialog v-drag:common title="任务详情" :visible.sync="modal" width="50%">
    <div class="task-detail-wrapper">
      <!-- <div class="task-detail-top">
        <p>协同工作详情</p>
        <p>
          <el-button type="primary" @click="goback">返回</el-button>
        </p>
      </div>-->
      <el-row>
        <el-col :span="8">
          <div>项目名称：{{ cowork.workName }}</div>
        </el-col>
        <el-col :span="8">
          <div>当前状态： {{ stateList }}</div>
        </el-col>
      </el-row>

      <!-- <el-col :span="14" v-if="cowork.state===0">
          <div>
            <a target="_blank" :href="downLoadUrl" class="download-class" v-if="cowork.path">下载</a>
            <el-upload
              ref="upload"
              :action="action"
              :auto-upload="false"
              :data="headers"
              :on-success="onFileUploadSuccess"
              :on-change="onChange"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <el-button type="primary" plain @click="uploadOrganization">提交</el-button>
          </div>
        </el-col>-->

      <!-- <el-col :span="18" v-else-if="cowork.state===5">
          <div>
            <a target="_blank" :href="downLoadUrl" class="download-class">下载</a>
          </div>
        </el-col>
        <el-col :span="18" v-else>
          <div class="other-status">
            <a target="_blank" :href="downLoadUrl" class="download-class">下载</a>
            <upload :workId="workId" :state="cowork.state"></upload>
          </div>
        </el-col>-->

      <!-- <p class="title">各部分撰写人</p>

      <el-row class="wrapper-row">
        <el-col :span="8">
          <div>概述：{{ cowork.summaryName }}</div>
        </el-col>
        <el-col :span="8">
          <div>风资源：{{ cowork.windName }}</div>
        </el-col>
        <el-col :span="8">
          <div>风场规划：{{ cowork.farmName }}</div>
        </el-col>
      </el-row>
      <el-row class="wrapper-row">
        <el-col :span="8">
          <div>载荷：{{ cowork.loadName }}</div>
        </el-col>
        <el-col :span="8">
          <div>经评：{{ cowork.economicName }}</div>
        </el-col>
        <el-col :span="8">
          <div>其他：{{ cowork.otherName }}</div>
        </el-col>
      </el-row> -->
      <p class="title">工作协同流程</p>
      <el-row class="wrapper-row">
        <el-col :span="8">
          <div>
            撰写：
            <span
              v-for="item in uploadUserList"
              :key="item"
              class="name-span"
              >{{ item.name }}</span
            >
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            检阅：
            <span
              v-for="item in reviewUserList"
              :key="item"
              class="name-span"
              >{{ item.name }}</span
            >
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            验查：
            <span v-for="item in checkUserList" :key="item" class="name-span">{{
              item.name
            }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="wrapper-row">
        <el-col :span="8">
          <div>
            会签：
            <span v-for="item in signUserList" :key="item" class="name-span">{{
              item.name
            }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            核定：
            <span
              v-for="item in approveUserList"
              :key="item"
              class="name-span"
              >{{ item.name }}</span
            >
          </div>
        </el-col>
      </el-row>
      <p class="title">流程进度</p>
      <el-row style="padding:0 20px">
        <el-steps
          :active="cowork.state == 5 ? 6 : cowork.state"
          finish-status="success"
        >
          <el-step title="撰写"></el-step>
          <el-step title="检阅"></el-step>
          <el-step title="验查"></el-step>
          <el-step title="会签"></el-step>
          <el-step title="核定"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </el-row>
      <el-table
        :data="recordList"
        :style="{ width: '95%', margin: '0 auto', backgroundColor: '#3b3a39' }"
        height="230"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="operation"
          label="操作过程"
          width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="opeName"
          label="操作人员"
          width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="opeTime"
          label="操作时间"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="result"
          label="结论"
          align="center"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="memo"
          label="意见"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="附件" width="70px" align="center">
          <template slot-scope="scope">
            <a
              :href="getHref(scope.row)"
              style="color: #fff"
              v-if="scope.row.path"
              >下载</a
            >
            <a v-else></a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils';
// import Upload from './upload';
export default {
  // components: { Upload },
  props: ['visible', 'id'],
  data() {
    return {
      file: '',
      modal: false,
      action: `${process.env.VUE_APP_API_HOST_WORK}/cowork/project/upload`,
      // headers: {
      //   workId: this.id,
      //   apiKey
      // },
      // workId: this.id,
      menu: [
        { type: '创建任务', path: '/task/add' },
        { type: '任务列表', path: '/task/list' },
        { type: '历史任务', path: '/task/history' },
        { type: '统计分析', path: '/task/analysis' }
      ],
      data: {},
      reviewUserList: [],
      uploadUserList: [],
      signUserList: [],
      recordList: [],
      checkUserList: [],
      approveUserList: [],
      cowork: {},
      downLoadUrl: `${
        process.env.VUE_APP_API_HOST_WORK
      }/cowork/project/coworkDown?apiKey=${getToken()}&workId=${this.id}`
    };
  },
  watch: {
    modal(val) {
      this.$emit('update:visible', val);
    },
    async visible(val) {
      this.modal = val;
      if (val) {
        await this.setup();
      }
    }
  },
  computed: {
    stateList() {
      if (this.cowork.state === 0) return '撰写中';
      if (this.cowork.state === 1) return '检阅中';
      if (this.cowork.state === 2) return '验查中';
      if (this.cowork.state === 3) return '会签中';
      if (this.cowork.state === 4) return '核定中';
      if (this.cowork.state === 5) return '完成';
      return '';
    }
  },
  async mounted() {
    // await this.setup()
  },
  methods: {
    async setup() {
      const { data } = await this.$fetch.get('/cowork/project/getCoworkInfo', {
        module: 'work',
        params: { workId: this.id }
      });
      const {
        reviewUserList,
        uploadUserList,
        signUserList,
        recordList,
        checkUserList,
        approveUserList,
        cowork
      } = data;
      this.reviewUserList = reviewUserList;
      this.uploadUserList = uploadUserList;
      this.signUserList = signUserList;
      this.recordList = recordList;
      this.checkUserList = checkUserList;
      this.approveUserList = approveUserList;
      this.cowork = cowork;
    },
    getHref(row) {
      return `${
        process.env.VUE_APP_API_HOST_WORK
      }/cowork/project/recordDown?apiKey=${getToken()}&recordId=${
        row.recordId
      }`;
    },
    async uploadOrganization() {
      if (!this.file) {
        return this.$message({
          message: '请上传文件',
          type: 'error'
        });
      }
      this.$refs.upload.submit();
      await this.setup();
    },
    onChange(file) {
      this.file = file;
    },
    onFileUploadSuccess(response) {
      this.$refs.upload.clearFiles();
      this.file = '';
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        return;
      }
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    onFileSelectError() {
      this.file = '';
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  margin-top: 80px !important;
}
/deep/.el-dialog__body {
  padding-left: 0px !important;
  padding-right: 0px;
}

.task-detail-wrapper {
  padding: 5px 0px;
  .task-detail-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    font-size: 18px;
  }
  /deep/.el-row {
    padding-left: 30px;
  }
  /deep/.el-col {
    font-size: 14px;
    color: #ffffff;
    line-height: 36px;
  }

  .title {
    color: #ffffff;
    padding-left: 5px;
    font-size: 13px;
    background-color: #0477a1b3;
    line-height: 26px;
  }

  .status-p {
    font-size: 14px;
    color: #ffffff;
    margin-right: 20px;
  }
  .name-span {
    display: inline-block;
    margin-right: 20px;
  }
  .other-status {
    padding-left: 70px;
  }
  .download-class {
    color: green;
  }
  .upload-class {
    margin-right: 10px;
  }
  // .wrapper-row {
  //   // padding-left: 50px;
  // }
}
/deep/.container-layout .container-layout-content > .el-main {
  border: none !important;
}
</style>
<style lang="less" scoped>
/deep/.el-table th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(odd) {
  background-color: #1e608f;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(even) {
  background-color: #126e6d;
  color: #fff;
}
/deep/.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px dashed #94969a;
  padding: 0px;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0477a1;
}
/deep/.el-table__body tr.current-row > td {
  background-color: #0477a1;
}
/deep/.el-step__title.is-process {
  color: #f56c6c;
}
/deep/.el-step__head.is-process {
  border-color: #f56c6c;
  color: #f56c6c;
}
</style>
